module.exports = __webpack_public_path__ + "img/info.a8c8ae81.png";